import { createApp } from "vue";
import { createPinia } from "pinia";
import Toast from "vue-toastification";

import App from "./App.vue";
import router from "./router";
import "./style.css";
import "vue-toastification/dist/index.css";
import "bootstrap-icons/font/bootstrap-icons.css";

// Create Vue app
const app = createApp(App);

// Configure Pinia store
const pinia = createPinia();
app.use(pinia);

// Use Vue Router (already configured with guard)
app.use(router);

// Configure Toast notifications
app.use(Toast, {
  transition: "Vue-Toastification__bounce",
  maxToasts: 20,
  newestOnTop: true,
  position: "top-right",
  timeout: 5000,
  closeOnClick: true,
  pauseOnFocusLoss: true,
  pauseOnHover: true,
  draggable: true,
  draggablePercent: 0.6,
  showCloseButtonOnHover: false,
  hideProgressBar: false,
  closeButton: "button",
  icon: true,
  rtl: false,
});

// Mount the app
app.mount("#app");
